import { useState, useEffect } from "react";
import { api } from "@/api/client";

interface SubscriptionState {
  subscribed: boolean;
  loading: boolean;
  productSlug: string;
  // From addons/my
  remainingDays?: number;
  priceLabel?: string;
  addonName?: string;
  expiresAt?: number;
}

export function useSubscription() {
  const [state, setState] = useState<SubscriptionState>({
    subscribed: false,
    loading: true,
    productSlug: "",
  });

  useEffect(() => {
    (async () => {
      try {
        let subscribed = false;
        let remainingDays: number | undefined;
        let priceLabel: string | undefined;
        let addonName: string | undefined;
        let expiresAt: number | undefined;

        // 天鼎AI 付费状态由 addon 订阅决定，不是由基础产品订阅决定
        try {
          const my: any = await api.get("/addon/my");
          const active = (my?.addons || []).find((x: any) => x.status === "active");
          if (active) {
            subscribed = true;
            // 后端可能仍返回旧品牌名；仅转换前端显示，不修改接口数据。
            addonName = active.addonName?.replace("研牛AI", "天鼎AI") || "天鼎AI";
            priceLabel = active.priceLabel || active.addonLabel || "";
            expiresAt = active.expiresAt || 0;
            if (expiresAt > 0) {
              remainingDays = Math.max(0, Math.ceil((expiresAt * 1000 - Date.now()) / 86400000));
            }
          }
        } catch {
          // Addon 查询失败时保持未订阅状态，由页面继续显示基础功能。
        }

        setState({ subscribed, loading: false, productSlug: "beta", remainingDays, priceLabel, addonName, expiresAt });
      } catch {
        setState({ subscribed: false, loading: false, productSlug: "" });
      }
    })();
  }, []);

  return state;
}
